import React, { useEffect } from "react";
import { useAuth } from "../../../../app/AuthContext";
import { SIGAAssistantProps } from "./types";
import { useDashboardData } from "./hooks/useDashboardData";
import { useChat } from "./hooks/useChat";
import { GeminiService } from "./services/gemini-service";
import { ChatHeader } from "./components/ChatHeader";
import { ChatContainer } from "./components/ChatContainer";
import { ChatInput } from "./components/ChatInput";

export default function SIGAAssistant({
  onClose,
  apiBaseUrl = "http://localhost:8000",
  apiToken,
  geminiApiKey,
}: SIGAAssistantProps) {
  const authContext = useAuth();
  const user = authContext?.user;
  const token = authContext?.token;

  const finalToken = apiToken || token;
  const finalUserId = user?.id || "";

  const { dashboardData, alunosRiscoData, turmasData } = useDashboardData(
    apiBaseUrl,
    finalToken,
  );

  const {
    messages,
    loading,
    uploadedFile,
    processUserMessage,
    handleFileUpload,
    handleRemoveFile,
  } = useChat(
    finalUserId,
    finalToken || "",
    dashboardData,
    alunosRiscoData,
    turmasData,
  );

  const geminiServiceRef = React.useRef<GeminiService | null>(null);

  useEffect(() => {
    if (geminiApiKey) {
      geminiServiceRef.current = new GeminiService(geminiApiKey);
    }
  }, [geminiApiKey]);

  const [input, setInput] = React.useState("");

  const handleSend = () => {
    if (!input.trim() && !uploadedFile) return;
    processUserMessage(input, uploadedFile || undefined);
    setInput("");
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-0 sm:p-4 z-50 backdrop-blur-sm">
      <div
        className="w-full max-w-5xl h-full sm:h-[85vh] flex flex-col overflow-hidden border-0 sm:border sm:rounded-2xl shadow-2xl"
        style={{
          backgroundColor: "var(--card-bg)",
          borderColor: "var(--border-color)",
        }}
      >
        <ChatHeader onClose={onClose} />

        <ChatContainer messages={messages} loading={loading} />

        <ChatInput
          input={input}
          onInputChange={setInput}
          onSend={handleSend}
          uploadedFile={uploadedFile}
          onFileUpload={handleFileUpload}
          onRemoveFile={handleRemoveFile}
          loading={loading}
        />
      </div>
    </div>
  );
}
